import React from "react";
export const SideNavContext = React.createContext({
    isExpand : true,
    toogleExpand: () =>{},
});

export default SideNavContext;